import React, { useState } from 'react';
import { XIcon, ShieldIcon, FileTextIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 text-center border-t border-slate-800 bg-[#0f172a]" data-id="element-20">
        <p className="text-slate-500 mb-4" data-id="element-21">
          © {new Date().getFullYear()} Sistemas ADHD para Parejas. Todos los
          derechos reservados.
        </p>
        <div className="flex items-center justify-center gap-6" data-id="element-22">
          <button onClick={() => setActiveModal('privacy')} className="text-slate-500 hover:text-amber-400 transition-colors text-sm underline underline-offset-4" data-id="element-23">
            Política de Privacidad
          </button>
          <span className="text-slate-700" data-id="element-24">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-slate-500 hover:text-amber-400 transition-colors text-sm underline underline-offset-4" data-id="element-25">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-26">
          <div className="relative w-full max-w-2xl max-h-[80vh] bg-slate-900 border border-slate-700 rounded-2xl shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-27">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-slate-800" data-id="element-28">
              <div className="flex items-center gap-3" data-id="element-29">
                {activeModal === 'privacy' ? <ShieldIcon className="w-5 h-5 text-teal-400" data-id="element-30" /> : <FileTextIcon className="w-5 h-5 text-amber-400" data-id="element-31" />}
                <h2 className="text-xl font-bold text-white" data-id="element-32">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
              </div>
              <button onClick={() => setActiveModal(null)} className="p-2 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800 transition-colors" aria-label="Cerrar" data-id="element-33">
                <XIcon className="w-5 h-5" data-id="element-34" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-slate-300 leading-relaxed space-y-4 text-sm" data-id="element-35">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-36" /> : <TermsContent data-id="element-37" />}
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-slate-400 text-xs" data-id="element-38">Última actualización: marzo 2026</p>

      <h3 className="text-lg font-semibold text-white pt-2" data-id="element-39">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-40">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el producto digital: nombre, dirección de correo
        electrónico y datos de pago. No almacenamos información de tarjetas de
        crédito directamente; los pagos son procesados por plataformas de pago
        seguras de terceros.
      </p>

      <h3 className="text-lg font-semibold text-white pt-2" data-id="element-41">
        2. Uso de la Información
      </h3>
      <p data-id="element-42">
        Tu información se utiliza exclusivamente para: procesar y entregar tu
        compra, enviarte el material adquirido, y comunicarnos contigo sobre
        actualizaciones del producto. No vendemos, alquilamos ni compartimos tu
        información personal con terceros con fines de marketing.
      </p>

      <h3 className="text-lg font-semibold text-white pt-2" data-id="element-43">
        3. Protección de Datos
      </h3>
      <p data-id="element-44">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, pérdida o
        alteración.
      </p>

      <h3 className="text-lg font-semibold text-white pt-2" data-id="element-45">4. Cookies</h3>
      <p data-id="element-46">
        Este sitio puede utilizar cookies esenciales para el funcionamiento
        básico y cookies analíticas para mejorar la experiencia del usuario.
        Puedes desactivar las cookies en la configuración de tu navegador.
      </p>

      <h3 className="text-lg font-semibold text-white pt-2" data-id="element-47">5. Tus Derechos</h3>
      <p data-id="element-48">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. Para ejercer estos derechos, contáctanos a través
        del correo electrónico proporcionado en tu confirmación de compra.
      </p>

      <h3 className="text-lg font-semibold text-white pt-2" data-id="element-49">
        6. Cambios en Esta Política
      </h3>
      <p data-id="element-50">
        Nos reservamos el derecho de actualizar esta política de privacidad.
        Cualquier cambio será publicado en esta página con la fecha de
        actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-slate-400 text-xs" data-id="element-51">Última actualización: marzo 2026</p>

      <h3 className="text-lg font-semibold text-white pt-2" data-id="element-52">
        1. Producto Digital
      </h3>
      <p data-id="element-53">
        "Sistemas ADHD para Parejas" es un producto digital educativo que
        incluye guías, plantillas y herramientas descargables. Este producto no
        constituye asesoramiento médico, psicológico ni terapéutico profesional.
      </p>

      <h3 className="text-lg font-semibold text-white pt-2" data-id="element-54">2. Uso Personal</h3>
      <p data-id="element-55">
        El material adquirido es para uso personal y de tu pareja únicamente.
        Queda prohibida la reproducción, distribución, reventa o compartición
        del contenido con terceros sin autorización expresa.
      </p>

      <h3 className="text-lg font-semibold text-white pt-2" data-id="element-56">3. Entrega</h3>
      <p data-id="element-57">
        Al completar la compra, recibirás acceso inmediato al material digital.
        Dado que se trata de un producto digital de descarga inmediata, todas
        las ventas son finales.
      </p>

      <h3 className="text-lg font-semibold text-white pt-2" data-id="element-58">
        4. Descargo de Responsabilidad
      </h3>
      <p data-id="element-59">
        Este producto ofrece herramientas y estrategias prácticas basadas en
        investigación sobre ADHD y dinámicas de pareja. Los resultados pueden
        variar según cada situación individual. No sustituye el diagnóstico
        médico, tratamiento farmacológico ni terapia profesional.
      </p>

      <h3 className="text-lg font-semibold text-white pt-2" data-id="element-60">
        5. Propiedad Intelectual
      </h3>
      <p data-id="element-61">
        Todo el contenido, diseño, textos y materiales incluidos en este
        producto están protegidos por derechos de autor. El uso no autorizado
        puede resultar en acciones legales.
      </p>

      <h3 className="text-lg font-semibold text-white pt-2" data-id="element-62">
        6. Limitación de Responsabilidad
      </h3>
      <p data-id="element-63">
        No nos hacemos responsables de daños directos o indirectos derivados del
        uso o la imposibilidad de uso del material proporcionado. El usuario
        asume toda la responsabilidad por la implementación de las estrategias
        descritas.
      </p>
    </>;
}